import {IWindowService} from './window.service.interface';
import {isAbsolutUrl} from '../../../utils/url-utils';
import { CGP_OBJECT_NAME } from '../../app-bootstrap/constants';
import { API } from '../../../sdk/src/core/api';
import { EventListenerRegistration } from '../../../utils/event-listener-registration';

declare global {
  interface Window {
    LOG_LEVEL: string;
    [CGP_OBJECT_NAME]: API;
    [key: string]: any;
  }
}

export class WindowService implements IWindowService {

  constructor() {
    this._eventListenerRegistration = new EventListenerRegistration(window);
  }
  getGlobalProperty(name: string): any {
    return window[name];
  }

  setGlobalProperty(name: string, value: any): void {
    window[name] = value;
  }

  getElementWidth(element: Element): number {
    return parseInt(window.getComputedStyle(element).width.replace('px', ''));
  }

  getElementHorizontalTranslationAmount(element: Element): number {
    let elementTransform = window.getComputedStyle(element).getPropertyValue("-webkit-transform") || window.getComputedStyle(element).getPropertyValue("transform");
    // we need split(",")[12] and [4] to support ie
    return parseInt(elementTransform.split(",")[12] || elementTransform.split(",")[4]) || 0;
  }

  get location(): Location {
    return window.location;
  }

  private readonly _eventListenerRegistration: EventListenerRegistration;
  get subscribeTo(): EventListenerRegistration {
    return this._eventListenerRegistration;
  }

  get innerWidth(): number {
    return window.innerWidth;
  }

  get innerHeight(): number {
    return window.innerHeight;
  }

  open(url?: string, target?: string, features?: string): void {
    window.open(url, target, features);
  }

  openSelf(url?: string): void {
    this.open(url, '_self')
  }

  get origin(): string {
    return window.location.origin;
  }

  get pathname(): string {
    return window.location.pathname;
  }

  get history(): History {
    return window.history;
  }

  scrollTo(x: number, y: number): void {
    window.scrollTo(x, y);
  }

  get scrollY(): number {
    return window.scrollY;
  }

  scrollBy(x: number, y: number): void {
    window.scrollBy(x, y)
  }

  isAbsolutUrl(url: string): boolean {
    return isAbsolutUrl(url);
  }

}
